import Vue from 'vue'
import axios from 'axios'

const ApiRequest = {}

ApiRequest.install = function(Vue, options) {

    Vue.prototype.$api = function(method, url, payload, params) {

        return new Promise(async (outerResolve, outerReject) => {

            params = params || {}
            payload = payload || {}
            url = url || '/'
            url = process.env.API_URL + url

            this.$snotify.async(params.title || '', params.body || '', () => new Promise(async (resolve, reject) => {

                try {
                    const response = await axios[method.toLowerCase()](url, payload)
                    outerResolve(response.data)
                    resolve({
                        title: this.$t('GENERAL.SUCCESS'),
                        body: params.success || this.$t('GENERAL.DONE'),
                        config: {
                            timeout: 2000,
                            pauseOnHover: false,
                            showProgressBar: true,
                        },
                    })

                } catch (e) {
                    let errorString = ''
                    const error = e.response && e.response.data ? e.response.data : {}
                    if (error.message)
                    {
                        errorString = error.message
                    }
                    if (e.response && e.response.status == 429)
                    {
                        errorString = this.$t('ERROR.TOOMANYREQUEST')
                    }
                    if (e.response && e.response.status == 500)
                    {
                        errorString = this.$t('ERROR.APIERROR')
                    }
                    if (e.response && e.response.status == 503)
                    {
                        errorString = this.$t('ERROR.APIDEPLOY')
                    }
                    if (error.errors)
                    {
                        const first = error.errors[Object.keys(error.errors)[0]]
                        if (first && first[0])
                            errorString = first[0]
                    }
                    
                    reject({
                        title: this.$t('GENERAL.ERROR'),
                        body:  errorString,
                        config: {
                            timeout: 2000,
                            pauseOnHover: false,
                            showProgressBar: true,
                        },
                    })
                    outerReject(e.response.data || {})

                }
            }), { timeout: 2000, showProgressBar: true, pauseOnHover: false })

        })
    }

}
Vue.use(ApiRequest)

export default ApiRequest


// WEBPACK FOOTER //
// ./src/plugins/apiRequest.js